// src/contexts/CompanySettingsContext.js
import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
import axiosInstance from '../utils/axiosInstance';

const CompanySettingsContext = createContext();

export const useCompanySettings = () => useContext(CompanySettingsContext);

export const CompanySettingsProvider = ({ children }) => {
    const [companyLogo, setCompanyLogo] = useState(null);
    const [loaded, setLoaded] = useState(false);

    const fetchCompanyLogo = useCallback(async () => {
        try {
            const response = await axiosInstance.get('/settings/company-settings');
            if (response.data?.success && response.data.data?.company_logo_url) {
                setCompanyLogo(response.data.data.company_logo_url);
            }
        } catch (err) {
            // Silently fail - will use default logo
        } finally {
            setLoaded(true);
        }
    }, []);

    useEffect(() => {
        fetchCompanyLogo();
    }, [fetchCompanyLogo]);

    const updateCompanyLogo = useCallback((logoUrl) => {
        setCompanyLogo(logoUrl || null);
    }, []);

    return (
        <CompanySettingsContext.Provider value={{ companyLogo, updateCompanyLogo, loaded }}>
            {children}
        </CompanySettingsContext.Provider>
    );
};
